import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { watch, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseAutoCompleteWithMultipleSelectedItems',
  props: {
    modelValue: {},
    label: {},
    itemName: {},
    items: {},
    managementOffice: {},
    operationOffices: {},
    errorMessages: {},
    readonly: { type: Boolean }
  },
  emits: ['update:modelValue', 'blur'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedItem = ref<any[] | undefined | null>(undefined);
const displayItems = ref<any[]>(props.items);

// 初期化
onMounted(() => {
  selectedItem.value = props.modelValue;
  filterItems();
});

// 変更を親コンポーネントに伝える
watch(
  () => selectedItem.value,
  (newValue) => {
    emit('update:modelValue', newValue);
  }
);

// modelValueが変更された時にselectedItemを更新する
watch(
  () => props.modelValue,
  (newValue) => {
    selectedItem.value = newValue;
  }
);

// operationOffice
// managementOffice
// items
// が変更された時にdisplayItemsを更新する
watch(
  () => [props.operationOffices, props.managementOffice, props.items],
  () => {
    filterItems();
  }
);

const filterItems = () => {
  let result = props.items;
  if (props.managementOffice !== undefined && props.managementOffice !== null) {
    result = result.filter(
      (item) =>
        item?.managementOfficeId === props.managementOffice?.id &&
        item?.managementOfficeType === props.managementOffice?.type // management officeのIDは重複する可能性があるので、typeで絞り込む。
    );
  }

  if (
    props.operationOffices !== undefined &&
    props.operationOffices !== null &&
    props.operationOffices.length > 0
  ) {
    result = result.filter((item) =>
      props.operationOffices?.some(
        (office) => office.id === item?.operationOfficeId
      )
    );
  }
  displayItems.value = result;

  // 選択されているitemがdisplayItemsに含まれていない場合は選択を解除する
  if (selectedItem.value !== undefined && selectedItem.value !== null) {
    selectedItem.value = selectedItem.value.filter((item) =>
      result.some((resultItem) => resultItem?.id === item?.id)
    );
  }
};

const emitBlur = () => {
  emit('blur');
};

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps({
    label: __props.label,
    modelValue: selectedItem.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
    onBlur: emitBlur,
    items: displayItems.value,
    "item-title": __props.itemName,
    "item-value": __props.itemName
  }, { 'return-object': true }, {
    multiple: "",
    readonly: __props.readonly,
    "error-messages": props.errorMessages
  }), null, 16, ["label", "modelValue", "items", "item-title", "item-value", "readonly", "error-messages"]))
}
}

})